import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Link } from '@tanstack/react-router';
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from '@ui/primitives/breadcrumb';
import { useTypedParams } from '@ui/routes';
import { useGetProject } from 'ze-sdk';
import { OrgSelectorDropdown } from './org-selector-dropdown';
export function AppBreadcrumb() {
    var _ref, _ref1;
    const { organization, project, application } = useTypedParams();
    const canFetchProject = Boolean(organization && project);
    const { data: projectResponse } = useGetProject({
        organization: organization !== null && organization !== void 0 ? organization : '',
        project: project !== null && project !== void 0 ? project : ''
    }, undefined, {
        query: {
            enabled: canFetchProject
        }
    });
    const projectValue = projectResponse === null || projectResponse === void 0 ? void 0 : projectResponse.value;
    const projectLabel = (_ref = (_ref1 = projectValue === null || projectValue === void 0 ? void 0 : projectValue.displayName) !== null && _ref1 !== void 0 ? _ref1 : project) !== null && _ref !== void 0 ? _ref : '';
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(OrgSelectorDropdown, {}),
            /*#__PURE__*/ _jsx(Breadcrumb, {
                children: /*#__PURE__*/ _jsxs(BreadcrumbList, {
                    children: [
                        project && organization && /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx(BreadcrumbSeparator, {
                                    className: "px-2"
                                }),
                                /*#__PURE__*/ _jsx(BreadcrumbItem, {
                                    children: application ? /*#__PURE__*/ _jsx(BreadcrumbLink, {
                                        asChild: true,
                                        children: /*#__PURE__*/ _jsx(Link, {
                                            to: "/org/$organization/$project",
                                            params: {
                                                organization,
                                                project
                                            },
                                            children: projectLabel
                                        })
                                    }) : /*#__PURE__*/ _jsx(BreadcrumbPage, {
                                        children: projectLabel
                                    })
                                })
                            ]
                        }),
                        application && /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx(BreadcrumbSeparator, {
                                    className: "px-2"
                                }),
                                /*#__PURE__*/ _jsx(BreadcrumbItem, {
                                    children: /*#__PURE__*/ _jsx(BreadcrumbPage, {
                                        children: application
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
